// extracted by mini-css-extract-plugin
module.exports = {"xroofContainer":"XRoof_styles_xroofContainer__2Sd47"};